import React from "react";
import { FxWindow } from "../windows/FxWindows";
import { FxmsData } from "../datas/FxData";

/**
 * 버튼에 대한 행위를 정의한 클래스
 *
 * 개발자 : T/F팀.
 * 개발년월 : 2022.11.
 */
export class FxAction {

  /**
   *
   * @param {*} attr 기능정의속성
   * @param {*} inputData  입력값
   * @param {*} id 선택된 값의 ID
   * @param {*} callback action이 끝나고 실행될 함수
   */
  constructor(attr, inputData, id, callback) {
    this.attr = attr;
    this.inputData = inputData;
    this.id = id;
    this.opObj = attr.linkOpObj;
    this.callback = callback;    

    console.log('*** FxAction ***      attr = ', this.attr);
    console.log('*** FxAction ***     opObj = ', this.opObj);
    console.log('*** FxAction *** inputData = ', this.inputData);
    console.log('*** FxAction *** inputData = ', this.callback);
  }

  /**
   * 버튼이 클릭 되었을 때
   * @returns
   */
  click() {

    // 기능 동작 여부 확인
    if (this.checkOpObj() === false) {
      return;
    }

    // 각 기능별 수행
    if (this.opObj.isSelect()) {
      this.select();
    } else if (this.opObj.isInsert()) {
      this.execute();
    } else if (this.opObj.isUpdate()) {
      this.execute();
    } else if (this.opObj.isDelete()) {
      this.execute();
    } else {
      FxWindow.alert('행위가 정의되지 않았습니다.', true);
    }
  }

  /**
   * 기능 처리 여부 확인
   * @returns
   */
  checkOpObj() {

    if (this.opObj === undefined || this.opObj === null) {
      FxWindow.alert('처리 요청 내역을 알 수 없습니다.', true);
      return false;
    }

    return true;
  }

  /**
   * 조회 기능 수행
   *
   * @returns
   */
  select() {

    if (this.checkOpObj() === false) {
      return;
    }
    if (this.checkInData('filter') === false) {
      return;
    }

    const attr = this.attr;
    const selectOpObj = this.opObj;

    if (attr.callback === undefined) {
      FxWindow.alert("조회한 데이터를 받을 곳을 지정하지 않았습니다.", true);
      return;
    }

    const sortAttr = selectOpObj.getAttrSort();
    FxmsData.selectGridData(selectOpObj.opUri, this.inputData, sortAttr.attrName, sortAttr.attrTypeCd).then(function (res) {
      attr.callback(true, selectOpObj, res);
      FxWindow.alert("[" + selectOpObj.opName + "] " + res.data.length + " 건의 데이터가 조회되었습니다.");
    }).catch(function (res) {
      attr.callback(false, selectOpObj, res);
      FxWindow.alert("조회중 오류가 발행되었습니다.", true);
    });

  }

  /**
   * 입력, 수정, 삭제 기능 수행
   *
   * @param {*} callback
   * @returns
   */
  execute(callback = undefined) {

    const _callback = callback ? callback : this.attr.callback;

    if (this.checkOpObj() == false) {
      return;
    }

    const attr = this.attr;
    const opObj = this.opObj;
    const THIS = this;

    if (opObj.isInsert()) {

      if (this.checkInData('input') === false) {
        return;
      }

      let cnfmMsg = opObj.cnfmMsg ? opObj.cnfmMsg : '전송하시겠습니까?';

      FxWindow.confirm(cnfmMsg, function (bret) {

        if (bret === false) return;
        FxmsData.insert(opObj.opUri, THIS.inputData).then(function (ret) {
          if (_callback) _callback(THIS.inputData);
      
          FxWindow.alert(opObj.okMsg ? opObj.okMsg : '등록이 완료되었습니다.');
          
          // THIS.callback이 함수인지 확인 후 호출
          if (typeof THIS.callback === 'function') {
            THIS.callback();
          }
      
        }).catch(function (ret) {
          console.log("FxAction POST 에러:", ret);
          try {
            FxWindow.alert((opObj.errMsg ? opObj.errMsg : '오류가 발생하였습니다.') + "\n\n" + ret.response.data.message, true);
          } catch (error) {
            FxWindow.alert(opObj.errMsg ? opObj.errMsg : '오류가 발생하였습니다.', true);
          }
        });
      });

    } else if (opObj.isDelete()) {

      if (THIS.id === undefined || this.id === null) {
        FxWindow.alert('선택된 데이터가 없습니다.', true);
        return;
      }

      let cnfmMsg = opObj.cnfmMsg ? opObj.cnfmMsg : '삭제할까요?';

      FxWindow.confirm(cnfmMsg, function (bret) {

        if (bret === false) return;

        const url = opObj.opUri + (THIS.id ? '/' + THIS.id : '');
        FxmsData.delete(url, THIS.inputData).then(function (ret) {

          if (_callback) _callback(THIS.inputData);

          FxWindow.alert(opObj.okMsg ? opObj.okMsg : '삭제되었습니다.');

        }).catch(function (ret) {

          console.log("delete error", ret);

          try {
            FxWindow.alert((opObj.errMsg ? opObj.errMsg : '오류가 발생하였습니다.') + "\n\n" + ret.response.data.message, true);
          } catch (error) {
            FxWindow.alert(opObj.errMsg ? opObj.errMsg : '오류가 발생하였습니다.', true);
          }
        });
      });

    } else if (opObj.isUpdate()) {

      if (this.checkInData('input') === false) {
        return;
      }

      let cnfmMsg = opObj.cnfmMsg ? opObj.cnfmMsg : '수정할까요?';

      FxWindow.confirm(cnfmMsg, function (bret) {

        if (bret === false) return;

        const url = opObj.opUri + (THIS.id ? '/' + THIS.id : '');

        FxmsData.update(url, THIS.inputData).then(function (ret) {

          if (_callback) _callback(THIS.inputData);

          FxWindow.alert(opObj.okMsg ? opObj.okMsg : '수정되었습니다.');
          
          // THIS.callback이 함수인지 확인 후 호출
          if (typeof THIS.callback === 'function') {
            THIS.callback();
          } else {
            console.log("THIS.callback이 함수가 아닙니다:", THIS.callback);
          }

        }).catch(function (ret) {
          try {
            FxWindow.alert((opObj.errMsg ? opObj.errMsg : '오류가 발생하였습니다.') + "\n\n" + ret.response.data.message, true);
          } catch (error) {
            FxWindow.alert(opObj.errMsg ? opObj.errMsg : '오류가 발생하였습니다.', true);
          }
        })
      });
    }
  }

  /**
   * 필수 입력 항목에 데이터 존재하는지 확인
   *
   * @param {*} attrGrp
   * @returns
   */
  checkInData(attrGrp) {
    const opObj = FxmsData.getOpObj(this.attr.opId);
    let msg = '';

    for (const a of opObj.attrList) {
      if (a.attrGrp === attrGrp && a.isNullable() === false) {
        if (this.inputData[a.attrName] === undefined || this.inputData[a.attrName] === null || this.inputData[a.attrName] === '') {
          msg += (msg === '' ? '' : ', ') + a.attrUiTxt;
        }
      }
    }

    if (msg === '' || msg === '인증번호') {
      return true;
    } else {
      FxWindow.alert("다음 항목이 입력되지 않았습니다. :: " + msg, true);
      return false;
    }
  }

  render() {

    // const opObj = FxmsData.getOpObj(this.opId);

    return (
      <>
        {/* <FxResource menu={opObj} /> */}
      </>
    );
  }


  componentWillMount() {
    console.log('*** FxAction ***  componentWillMount');
  }

  componentDidMount() {
    console.log('*** FxAction ***  componentDidMount');
  }


  componentWillUnmount() {
    console.log('*** FxAction ***  componentWillUnmount');
  }
}


/**
 * URL 호출
 * 
 */
export class FxActionBase {

  constructor(url, method, cnfmMsg, okMsg, errMsg) {
    this.url = url;
    this.method = method;
    this.cnfmMsg = cnfmMsg ? cnfmMsg : '처리 하시겠습니까?';
    this.okMsg = okMsg ? okMsg : '정상 처리 되었습니다.';
    this.errMsg = errMsg ? errMsg : '처리중 오류가 발생하였습니다.';
  }

  /**
   * 기능 처리 여부 확인
   * @returns
   */
  #checkOpObj() {
    return true;
  }

  /**
   * 필수 입력 항목에 데이터 존재하는지 확인
   *
   * @param {*} para
   * @returns
   */
  #checkInData(para) {
    return true;
  }

  /**
   * 조회 기능 수행
   *
   * @returns
   */
  select(para, callback) {

    if (this.#checkOpObj() === false) {
      return;
    }
    if (this.#checkInData() === false) {
      return;
    }

    if (callback === undefined) {
      FxWindow.alert("조회한 데이터를 받을 곳을 지정하지 않았습니다.", true);
      return;
    }

    FxmsData.selectGridData(this.url, para).then(function (res) {
      callback(true, res.data);
      FxWindow.alert(res.data.length + " 건의 데이터가 조회되었습니다.");
    }).catch(function (res) {
      console.log("FxActionBase error ", res);
      callback(false, res);
      FxWindow.alert("조회중 오류가 발행되었습니다.", true);
    });

  }

  /**
   * 입력, 수정, 삭제 기능 수행
   *
   * @param {*} callback
   * @returns
   */
  execute(para, callback) {

    if (this.#checkOpObj(para) == false) {
      return;
    }
    if (this.#checkInData(para) === false) {
      return;
    }

    const THIS = this;
    const cnfmMsg = this.cnfmMsg;
      // + "\n\n"
      // + JSON.stringify(para);

    FxWindow.confirm(cnfmMsg, function (bret) {

      if (bret === false) return;

      console.log("FxActionBase method,url,para", THIS.method, THIS.url, para);

      if (THIS.method === 'POST') {
        console.log("FxActionBase POST 시작:", THIS.url, para);
        FxmsData.insert(THIS.url, para).then(function (ret) {
          console.log("FxActionBase POST 성공:", ret);
          if (callback) callback(true, para);
          FxWindow.alert(THIS.okMsg);
        }).catch(function (ret) {
          console.log("FxActionBase POST 에러:", ret);
          try {
            FxWindow.alert(THIS.errMsg + "\n\n" + ret.response.data.message, true);
          } catch (error) {
            FxWindow.alert(THIS.errMsg, true);
          }
        });
      } else if (THIS.method === 'DELETE') {
        FxmsData.delete(THIS.url, para).then(function (ret) {
          if (callback) callback(true, para);
          FxWindow.alert(THIS.okMsg);
        }).catch(function (ret) {
          console.log("FxActionBase error ", ret);
          try {
            FxWindow.alert(THIS.errMsg + "\n\n" + ret.response.data.message, true);
          } catch (error) {
            FxWindow.alert(THIS.errMsg, true);
          }
        });
      } else if (THIS.method === 'PUT') {
        FxmsData.update(THIS.url, para).then(function (ret) {
          if (callback) callback(true, para);
          FxWindow.alert(THIS.okMsg);
        }).catch(function (ret) {
          console.log("FxActionBase error ", ret);
          try {
            FxWindow.alert(THIS.errMsg + "\n\n" + ret.response.data.message, true);
          } catch (error) {
            FxWindow.alert(THIS.errMsg, true);
          }
        });
      }
    });
  }


  render() {
    return (
      <>
      </>
    );
  }


  componentWillMount() {
  }

  componentDidMount() {
  }


  componentWillUnmount() {
  }
}